<template>
  <div class="wrapper">
    <FORM ref="childForm" @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable" @checkbox="checkbox" @btnclick="bthClick" :pageData="pageData"></table-page>
    <!-- 弹窗, 新增 / 修改 -->
    <cashInUpdate v-show="addOrUpdateVisible" @refreshDataList="refreshDataList" ref="cashInUpdate"></cashInUpdate>
  </div>
</template>

<script>
    //table封装组件
    import tablePage from '@/components/page/table.vue'
    import FORM from '@/components/page/form.vue'
    import cashInUpdate from '@/views/newmis36/payment/cashInUpdate.vue'
    import Qs from 'qs'
    import URL from '@/views/newmis36/util/url'
    let platform = {"GTS2": "TREX", "MT5": "MT5"};
    let bankPayMethod = {"P":"internet Bank","T":"ATM","RE":"Counter deposit","O":"Other"};
    export default {
        name: 'list',
        components: {
            tablePage,
            FORM,
            cashInUpdate
        },
        methods: {
            checkbox(row) {
                this.deleteIds = row.map(key => key.id).join(",");
            },
            /*表格按钮点击事件*/
            bthClick(clickName, row) {
                if (clickName == "update") {
                }
            },
            // 新增 / 修改
            addOrUpdateHandle() {
                this.addOrUpdateVisible = true;
                this.$nextTick(() => {
                    this.$refs.cashInUpdate.init();
                })
            },
            /*查询表单按钮点击事件*/
            formclick(clickName, data) {
                if ("查询" == clickName  || window.$t("common.search") == clickName) {
                    this.queryData = data;
                    this.$refs.childTable.defaultQueryData(data);
                } else if ("人工存款补单" == clickName) {
                    this.addOrUpdateHandle();
                }
            },
            /*新增或跟提交数据触发事件*/
            submit(model) {
                //根据是否包含id更新还是添加
                this.dataChanage(URL.payment.supplementSave, model, res => {
                    if (res.code == 0) {
                        this.$refs.childUpdate.close();
                        this.$message.success("suc");
                        this.$refs.childTable.defaultGetData(this.queryData);
                    } else {
                        this.$message.error("error");
                    }
                })
            },
            refreshDataList() {
                this.$refs.childTable.defaultGetData(this.queryData);
            },
            dataChanage(url, option, suc, fail) {
                this.axios.post(url, Qs.stringify(option || {})).then(res => {

                    if (suc && (typeof suc == 'function')) suc(res);
                }).catch(res => {
                    if (fail && (typeof fail == 'function')) fail(res);
                })
            }
        },
        data() {
            return {
                deleteIds: "",
                addOrUpdateVisible: false,   // 新增／更新，弹窗visible状态
                queryData: {},
                /*from查询表单*/
                formData: {
                    hasLable: true,
                    cols: [
                        {title: '提案号', field: 'pno'},
                        {click:  window.$t("common.search")},
                        {click: "人工存款补单"},
                    ]
                },
                /*table生成*/
                pageData: {
                    queryUrl: URL.payment.supplementList, //请求路径和参数
                    selection: true,
                    sequence: true,
                    cols: [
                        {title: '提案号', field: 'pno'},
                        {title: '交易账号', field: 'accountNo'},
                        {title: '交易平台', field: 'platform'},
                        {title: '存款货币', field: 'payCurrency'},
                        {title: '存款金额', field: 'payAmount'},
                        {title: '实际存款金额', field: 'adjustedActualPayAmount'},
                        {title: '手续费', field: 'fee'},
                        {title: '存款汇率', field: 'exchangeRate'},
                        {title: '支付网关结算货币', field: 'gatewayCurrency'},
                        {title: '发给支付平台金额', field: 'gatewayAmount'},
                        {title: '从支付平台收到金额', field: 'actualPayAmount'},
                        {title: '最终存款金额', field: 'transAmount'},
                        {title: '最后更新时间', field: 'updateDate'},
                        {title: '备注', field: 'remark'},
                    ]
                }
            }
        }
    }
</script>
